import { SvgProps } from 'react-native-svg';
import { CarWheelPosition } from './CarWheelPosition';
import type { CarWheelPositionType } from './carWheelLayout';

interface CarSideIconProps extends SvgProps {
  color?: string;
  carSide?: CarWheelPositionType;
}

const CarSideIcon = ({ carSide, width = 20, height = 33, ...rest }: CarSideIconProps) => (
  <CarWheelPosition carSides={carSide ? [carSide] : []} width={width} height={height} {...rest} />
);

export { CarSideIcon };
